<div class="content-div">
  <div class="info-bar">
    <app-breadcrumbs [breadcrumbs]="BreadcrumbsLink"></app-breadcrumbs>

    <app-basic-button type="secondary" isIcon="true" size="medium" (click)="openHelp()">
      <i class="far fa-info-circle fs-16"></i>
    </app-basic-button>
  </div>

  <div class="top-bar">
    <span class="page-header">
      {{ 'users:usersLog' | i18next : { defaultValue: 'Log' } }}
    </span>
  </div>

  <!-- Wait until settings are loaded -->
  <div class="content" *ngIf="logsSettings">

    <!-- AUDIT / CHANGE LOG -->
    <div class="accordion-section" *ngIf="showChangeLog">
      <div class="accordion-header" (click)="toggleAccordion('logs')">
        <h3>
          <i class="fas fa-chevron-right dropdown-button"
             [class.rotate-down]="accordionStates.logs"></i>
          {{ 'users:auditHeading' | i18next : { defaultValue: 'Change log' } }}
        </h3>
      </div>

      <div class="accordion-body" [style.display]="accordionStates.logs ? 'block' : 'none'">
        <!-- Child is created only when accordion is opened -->
        <app-audit-logs
          *ngIf="accordionStates.logs"
          [modulesModel]="modulesModel">
        </app-audit-logs>
      </div>
    </div>

    <!-- ACCESS / LOGIN LOG -->
    <div class="accordion-section" *ngIf="showAccessLog">
      <div class="accordion-header" (click)="toggleAccordion('access')">
        <h3>
          <i class="fas fa-chevron-right dropdown-button"
             [class.rotate-down]="accordionStates.access"></i>
          {{ 'users:loginLog' | i18next : { defaultValue: 'Login log' } }}
        </h3>
      </div>

      <div class="accordion-body" [style.display]="accordionStates.access ? 'block' : 'none'">
        <!-- Child is created only when accordion is opened -->
        <app-access-logs
          *ngIf="accordionStates.access"
          [modulesModel]="modulesModel">
        </app-access-logs>
      </div>
    </div>

  </div>
</div>
